import React from 'react';
import { Check } from 'lucide-react';
import type { Checklist } from '../../hooks/useChecklist';

/** Pasos numerados que el jugador puede marcar como completados. */
export function StepList({
  steps,
  list,
  prefix
}: {
  steps: string[];
  list: Checklist;
  prefix: string;
}) {
  return <ol className="space-y-1.5" data-id="element-1093" data-mp="1i9hcl4s0cm01">
      {steps.map((s, i) => {
      const key = `${prefix}:paso-${i}`;
      const done = list.isChecked(key);
      return <li key={key} data-id="element-1094" data-mp="ulr1ozm11mdf" data-mpi={i}>
            <label className={`flex min-h-[44px] cursor-pointer items-start gap-3 rounded-xl px-2 py-2 transition-colors duration-150 hover:bg-white/[0.03] ${done ? 'text-gray-500' : 'text-gray-200'}`} data-id="element-1095" data-mp="pkjw977cwz9x">
              <input type="checkbox" checked={done} onChange={() => list.toggle(key)} className="peer sr-only" data-id="element-1096" data-mp="yli0nqlpj8t1" />
              <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-xs font-bold peer-focus-visible:ring-2 peer-focus-visible:ring-[#D4AF37] ${done ? 'border-[#D4AF37] bg-[#D4AF37] text-[#050b14]' : 'border-white/20 text-gray-400'}`} aria-hidden="true" data-id="element-1097" data-mp="2eyyo40do929n">
                {done ? <Check className="h-3.5 w-3.5" data-id="element-1098" data-mp="2xwy4lpwfwrii" /> : i + 1}
              </span>
              <span className={`text-sm leading-relaxed md:text-[15px] ${done ? 'line-through decoration-white/20' : ''}`} data-id="element-1099" data-mp="32uhi2nlbd09e">{s}</span>
            </label>
          </li>;
    })}
    </ol>;
}

/** Cuenta los pasos marcados de una lista. */
export const countSteps = (steps: string[], list: Checklist, prefix: string) => steps.filter((_, i) => list.isChecked(`${prefix}:paso-${i}`)).length;